// extracted by mini-css-extract-plugin
export var sliderRange = "_nz-2";
export var sliderRoot = "_nz-0";
export var sliderThumb = "_nz-3";
export var sliderTrack = "_nz-1";